import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';

export function getScaleModel(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`ScaleModel`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getScaleModelId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`ScaleModel/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createScaleModel(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('ScaleModel', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateScaleModelId(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`ScaleModel/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function deleteScaleModelId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.delete(`ScaleModel/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

